// extracted by mini-css-extract-plugin
export default {"home-wrapper":"admin_home-wrapper__SOHwB","home-content":"admin_home-content__nLhkp","home-links":"admin_home-links__SdRok","home-link":"admin_home-link__JnJn0"};